import React, { memo } from 'react';
import classNames from 'classnames/bind';
import { Card, Tag, Text } from '@beef/ui-kit';
import { BadgeText } from "../BadgeText";
import { Icon } from "../Icon";
import styles from "./styles.module.pcss";
var cn = classNames.bind(styles);
export var Header = /*#__PURE__*/memo(function (_ref) {
  var badge = _ref.badge,
    forEsim = _ref.forEsim,
    labelSize = _ref.labelSize,
    availableOnlyInOffice = _ref.availableOnlyInOffice,
    discount = _ref.discount,
    title = _ref.title,
    titleSize = _ref.titleSize,
    isDark = _ref.isDark,
    cardType = _ref.cardType,
    isConnected = _ref.isConnected,
    connectedSettings = _ref.connectedSettings;
  return /*#__PURE__*/React.createElement("div", {
    className: cn('card-header', "card-header--".concat(cardType), {
      'card-header--flex-start': cardType !== 'max' && (badge === null || badge === void 0 ? void 0 : badge.type) && forEsim && availableOnlyInOffice
    }),
    "data-t-id": "components-Header"
  }, /*#__PURE__*/React.createElement("div", {
    className: cn('card-header__left', "card-header__left--".concat(cardType), {
      'card-header__left--discount': cardType !== 'max' && (discount === null || discount === void 0 ? void 0 : discount.label)
    })
  }, /*#__PURE__*/React.createElement(Text, {
    className: cn('title'),
    color: cardType !== 'max' && isDark ? 'white' : 'grey95',
    size: titleSize,
    tagType: "h3"
  }, title), (discount === null || discount === void 0 ? void 0 : discount.label) && /*#__PURE__*/React.createElement(Tag, {
    size: labelSize,
    variant: "magenta50"
  }, discount.label), isConnected && /*#__PURE__*/React.createElement("div", {
    className: cn('connected')
  }, /*#__PURE__*/React.createElement(Tag, {
    size: labelSize,
    textColor: "black",
    variant: (connectedSettings === null || connectedSettings === void 0 ? void 0 : connectedSettings.variant) || 'gold'
  }, (connectedSettings === null || connectedSettings === void 0 ? void 0 : connectedSettings.label) || 'Мой тариф'))), ((badge === null || badge === void 0 ? void 0 : badge.type) || forEsim || availableOnlyInOffice || isConnected) && /*#__PURE__*/React.createElement("div", {
    className: cn('card-header__right')
  }, ((badge === null || badge === void 0 ? void 0 : badge.type) || forEsim || availableOnlyInOffice) && /*#__PURE__*/React.createElement("div", {
    className: cn('badge', {
      'badge--wrap': forEsim && availableOnlyInOffice && (badge === null || badge === void 0 ? void 0 : badge.type)
    })
  }, (forEsim || availableOnlyInOffice) && /*#__PURE__*/React.createElement(BadgeText, {
    availableOnlyInOffice: availableOnlyInOffice,
    forEsim: forEsim,
    isDark: isDark && cardType !== 'max'
  }), (badge === null || badge === void 0 ? void 0 : badge.type) && /*#__PURE__*/React.createElement(Card, {
    className: cn('badge-icon')
  }, /*#__PURE__*/React.createElement(Icon, {
    name: badge.type,
    "data-t-id": "components-Header"
  }), badge.type === 'present' && (badge === null || badge === void 0 ? void 0 : badge.text) && /*#__PURE__*/React.createElement("div", {
    className: cn('badge-icon__description')
  }, /*#__PURE__*/React.createElement(Text, {
    size: "size4-r"
  }, badge.text))))));
});